export default {
  批量添加到客户库: 'Batch add to customer library',
  拍照识别: 'Photo Rco',
  自主创建: 'Self-created',
  群组描述不能为空: 'Group description cannot be empty',
  群组名称不能为空: 'Group name cannot be empty',
  我的群组: 'My group',
  请选择群组: 'Please select a group',
  条数据: 'piece of data',
  个云数据: 'cloud data',
  全选: 'Select All',
  取消选择: 'cancel selection',
  添加客户库: 'Add customer library',
  您的潜在客户: 'Your potential customers',
  累计触达客户量: 'Cumulative Customer Reach',
  涵盖行业提示: 'Currently covered industry categories',
  公海客户数量提示1: 'Currently has Cloud Customers',
  客户数量: 'number of customers',
  客户新增: 'New cloud data',
  触达客户量: 'Reaching customers',
  添加成功: 'Added Successfully!',
  云数据提示1: 'Please enter the enterprise name/business scope',
  企业名或经营范围: 'Enterprise name or business scope',
  客户详情: 'Customer Details',
  企业税号: 'Enterprise Tariff Item',
  邮编: 'Postcode',
  企业官网: 'Official Website',
  企业所在地: 'Enterprise Location',
  经营范围: 'Business Scope',
  客户来源: 'Customer Source',
  区域: 'Area',
  云数据提示语:
    'You can add your interested customers by searching in the website or you can contact them by using message marketing service on Big-data marketing system',
  企业数据: 'Enterprise Data',
  行业: 'Industry',
  '100万以内': 'Within 1 million',
  '100-200万': '1-2 million',
  '200-500万': '2-5million',
  '500-1000万': '5-10 million',
  '1000-5000万': '10-50 million',
  '5000万以上': 'More than 50 million',
  '1年内': 'Within 1 year',
  '1-3年': '1-3 years',
  '3-5年': '3-5 years',
  '5-10年': '5-10years',
  '10-30年': '10-30 years',
  '30年以上': 'More than 30 years',
}
